import React from 'react';
import { Theme } from './hooks';
import { Point } from '@/types';
import { PointBadge } from './PointBadge';
import { IconButton } from './IconButton';
import { CloseIcon, PlusIcon } from '@iconicicons/react';
import { BadgeDisplay } from './BadgeDisplay';

export type EditablePointListProps = {
  points?: Point[];
  theme: Theme;
  canAdd?: boolean;
  canRemove?: boolean;
  onAddPoint?: () => void;
  onRemovePoint?: (point: Point) => void;
};

export const EditablePointList: React.FC<EditablePointListProps> = ({
  points = [],
  theme,
  canAdd = false,
  canRemove = false,
  onAddPoint,
  onRemovePoint,
}) => {
  return (
    <>
      {points.map((point) => (
        <PointBadge
          key={point.id}
          point={point}
          theme={theme}
          extra_text={
            canRemove ? (
              <IconButton
                icon={CloseIcon}
                onClick={(evt) => {
                  evt.stopPropagation();
                  onRemovePoint?.(point);
                }}
              />
            ) : null
          }
        />
      ))}
      {canAdd && (
        <BadgeDisplay role="button" theme={theme} onClick={onAddPoint}>
          <PlusIcon />
        </BadgeDisplay>
      )}
    </>
  );
};
